import { render, staticRenderFns } from "./ShengneiRemenLuxian.vue?vue&type=template&id=12bb2608&scoped=true&"
import script from "./ShengneiRemenLuxian.vue?vue&type=script&lang=js&"
export * from "./ShengneiRemenLuxian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb2608",
  null
  
)

export default component.exports